import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { createBreakpoints } from "@mui/system";
import font from "./font";
import { Black, DarkGrey } from "./color";

/**
 * @dev Breakpoints for responsive design, we can use it in styled() function or sx prop
 */
const breakpoints = createBreakpoints({
  values: { xs: 0, sm: 541, md: 836, lg: 1025, xl: 1441 },
});

/**
 * @dev We can override the default theme of MUI here
 * or using styled() function to override specific components.
 */
const theme = createTheme({
  typography: {
    fontFamily: `"Poppins", "Prompt", "Caveat", sans-serif !important`,
  },
  paper: {
    width: "100%",
    maxWidth: "800px !important",
    borderRadius: "16px !important",
    padding: "24px !important",
  },
  // palette: {
  //   primary: {
  //     main: "#E13B30",
  //   },
  //   secondary: {
  //     main: "#F7CECB",
  //   },
  // },
  components: {
    MuiButton: {
      defaultProps: {
        disableFocusRipple: true,
      },
      variants: [
        {
          props: {
            size: "small",
          },
          style: {
            padding: "8px 16px",
            fontSize: font.size.xs,
          },
        },
        {
          props: {
            size: "medium",
          },
          style: {
            padding: "8px 24px",
            fontSize: font.size.sm,
          },
        },
        {
          props: {
            size: "large",
          },
          style: {
            padding: "12px 24px",
            fontSize: font.size.md,
          },
        },
      ],
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          subtitle1: "p",
          subtitle2: "p",
        },
      },
      variants: [
        {
          props: {
            variant: "subtitle1",
          },
          style: {
            fontSize: font.size.md,
            fontWeight: 500,
            lineHeight: 1.5,
            color: Black,
          },
        },
        {
          props: {
            variant: "subtitle2",
          },
          style: {
            fontSize: font.size.md,
            fontWeight: 500,
            color: DarkGrey,
          },
        },
        {
          props: {
            variant: "body1",
          },
          style: {
            fontSize: font.size.sm,
            fontWeight: 400,
            color: Black,

            [breakpoints.up("md")]: {
              fontSize: font.size.md,
            },
          },
        },
        {
          props: {
            variant: "body2",
          },
          style: {
            fontSize: font.size.sm,
            fontWeight: 400,
            color: DarkGrey,

            [breakpoints.up("md")]: {
              fontSize: font.size.md,
            },
          },
        },
      ],
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: "#D8D8DC",
        },
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 541,
      md: 836,
      lg: 1025,
      xl: 1441,
    },
  },
});

export default responsiveFontSizes(theme);
